var _rect, _g, _g2, _g3, _g4, _g5, _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSonicAdvantageTeaser04Small(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 326 432",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "a",
    width: 326,
    height: 432,
    x: 0,
    y: 0,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "alpha"
    }
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 432,
    height: 326,
    x: 326,
    fill: "#fff",
    rx: 28,
    transform: "rotate(90 326 0)"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#a)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 162.295,
    cy: -245.295,
    r: 414.705,
    fill: "url(#b)",
    transform: "rotate(90 162.295 -245.295)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#c)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 234.831,
    height: 174.428,
    x: 45.586,
    y: 40,
    fill: "#fff",
    rx: 4.931
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#d)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#e)",
    fillOpacity: 0.4,
    d: "M48.05 49.862a7.396 7.396 0 0 1 7.397-7.397h215.108a7.397 7.397 0 0 1 7.396 7.397v151.623a7.396 7.396 0 0 1-7.396 7.396H55.447a7.396 7.396 0 0 1-7.396-7.396V49.862Z"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#f)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 294.001,
    height: 11.711,
    x: 16,
    y: 208.882,
    fill: "#fff",
    rx: 4.931
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#g)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M93.045 80.063a4.93 4.93 0 0 1 4.93-4.93h130.051a4.93 4.93 0 0 1 4.931 4.93v94.302a4.93 4.93 0 0 1-4.931 4.931H97.976a4.93 4.93 0 0 1-4.931-4.931V80.063Z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.774,
    d: "M155.604 107.491a6.676 6.676 0 0 1 6.677-6.677 6.676 6.676 0 0 1 6.677 6.677v4.006h2.671c3.733 0 5.6 0 7.073.61a8.014 8.014 0 0 1 4.336 4.337c.61 1.472.61 3.339.61 7.072h4.006a6.677 6.677 0 0 1 0 13.355h-4.006v4.54c0 4.488 0 6.731-.873 8.445a8.014 8.014 0 0 1-3.502 3.502c-1.714.873-3.958.873-8.445.873h-1.87v-4.674a6.01 6.01 0 0 0-12.019 0v4.674h-3.205c-4.487 0-6.731 0-8.445-.873a8.014 8.014 0 0 1-3.502-3.502c-.873-1.714-.873-3.957-.873-8.445v-4.54h4.006a6.678 6.678 0 1 0 0-13.355h-4.006c0-3.733 0-5.6.61-7.072a8.014 8.014 0 0 1 4.336-4.337c1.473-.61 3.34-.61 7.073-.61h2.671v-4.006Z"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "c",
    width: 259.484,
    height: 199.082,
    x: 33.259,
    y: 30.138,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2.465
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6.164
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_301_7523"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "effect1_dropShadow_301_7523",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "d",
    width: 234.831,
    height: 171.346,
    x: 45.585,
    y: 40,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 1.233
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_301_7523"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_301_7523",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "f",
    width: 318.654,
    height: 36.365,
    x: 3.673,
    y: 199.02,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2.465
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6.164
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_301_7523"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "effect1_dropShadow_301_7523",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "g",
    width: 164.566,
    height: 128.818,
    x: 80.718,
    y: 65.271,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2.465
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6.164
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_301_7523"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "effect1_dropShadow_301_7523",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    x1: -30.065,
    x2: 7.271,
    y1: 133.221,
    y2: -408.894,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.001,
    stopColor: "#700013"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF2538"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "e",
    x1: 163.001,
    x2: 163.001,
    y1: 42.465,
    y2: 208.881,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3866C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3866C2",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSonicAdvantageTeaser04Small);
export default __webpack_public_path__ + "static/media/sonic-advantage-teaser-04-small.a0b6beb9edb5e4913083a63bb5095c54.svg";
export { ForwardRef as ReactComponent };